export default __webpack_public_path__ + "static/media/mars34.69f98be3.gif";